// reducer.js
import {
  GET_ALL_COMPANIES_SUCCCESS,
  GET_ALL_COMPANIES_ERROR,
  GET_ALL_DEALERSHIPS_SUCCCESS,
  GET_ALL_DEALERSHIPS_ERROR,
  GET_ALL_DEALERSHIPS_USERS_SUCCCESS,
  GET_ALL_DEALERSHIPS_USERS_ERROR,
  GET_ALL_BRANDS_SUCCCESS,
  GET_ALL_BRANDS_ERROR,
  GET_FUEL_SUCCCESS,
  GET_FUEL_ERROR,
  GET_ALL_TRANSMISSION_SUCCCESS,
  GET_ALL_TRANSMISSION_ERROR,
  GET_ALL_MODELS_SUCCCESS,
  GET_ALL_MODELS_ERROR,
  GET_ALL_VARIANTS_SUCCCESS,
  GET_ALL_VARIANTS_ERROR,
  GET_ALL_DMS_DATA_SUCCCESS,
  GET_ALL_DMS_DATA_ERROR,
  GET_ALL_DEALERSHIPS_LOADING,
} from "../actionTypes";

export const affiliationsInitialState = {
  error: null,
  companies: [],
  dealerShips: [],
  dealerShipsUsers: [],
  brands: [],
  fuels: [],
  transmissions: [],
  models: [],
  variants: [],
  DMS: [],
};

export default (state = affiliationsInitialState, action) => {
  switch (action.type) {
    case GET_ALL_COMPANIES_SUCCCESS:
      return {
        ...state,
        companies: action.payload,
        error: null,
      };
    case GET_ALL_COMPANIES_ERROR:
      return {
        ...state,
        companies: [],
        error: action.payload,
      };
    case GET_ALL_DEALERSHIPS_LOADING:
      return {
        ...state,
        dealerShips: affiliationsInitialState.dealerShips,
        error: null,
      };
    case GET_ALL_DEALERSHIPS_SUCCCESS:
      return {
        ...state,
        dealerShips: action.payload,
        error: null,
      };
    case GET_ALL_DEALERSHIPS_ERROR:
      return {
        ...state,
        dealerShips: [],
        error: action.payload,
      };
    case GET_ALL_DEALERSHIPS_USERS_SUCCCESS:
      return {
        ...state,
        dealerShipsUsers: action.payload,
        error: null,
      };
    case GET_ALL_DEALERSHIPS_USERS_ERROR:
      return {
        ...state,
        dealerShipsUsers: [],
        error: action.payload,
      };
    case GET_ALL_BRANDS_SUCCCESS:
      return {
        ...state,
        brands: action.payload,
        error: null,
      };
    case GET_ALL_BRANDS_ERROR:
      return {
        ...state,
        brands: [],
        error: action.payload,
      };
    case GET_FUEL_SUCCCESS:
      return {
        ...state,
        fuels: action.payload,
        error: null,
      };
    case GET_FUEL_ERROR:
      return {
        ...state,
        // fuels: [],
        error: action.payload,
      };
    case GET_ALL_TRANSMISSION_SUCCCESS:
      return {
        ...state,
        transmissions: action.payload,
        error: null,
      };
    case GET_ALL_TRANSMISSION_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case GET_ALL_MODELS_SUCCCESS:
      return {
        ...state,
        models: action.payload,
        error: null,
      };
    case GET_ALL_MODELS_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case GET_ALL_VARIANTS_SUCCCESS:
      return {
        ...state,
        variants: action.payload,
        error: null,
      };
    case GET_ALL_VARIANTS_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case GET_ALL_DMS_DATA_SUCCCESS:
      return {
        ...state,
        DMS: action.payload,
        error: null,
      };
    case GET_ALL_DMS_DATA_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
};
